<template>
  <div id="app">
    <Nav />
    <div class="pageMain">
      <div class="p20">
        <div class="f16">{{titleText}} {{$t('producDeta.commission')}}</div>
        <div class="boxText pt10">
          {{$t('producDeta.title')}}
        </div>

        <div class="worksViewList pt30" v-for="(item,key) in contents" :key="key">
          <div class="worksViewMain">
            <div class="worksViewRow flex" v-if="key%2 == 0">
              <div class="worksViewInfo flex-1">
                <div class="f14 fb">{{$i18n.locale == 'zh'?item.name:item.name2}}</div>
                <div class="f14">{{$i18n.locale == 'zh'?item.title1:item.title2}}</div>
                <div class="worksViewPy">{{item.name3}}<br />{{item.name4}}</div>
              </div>
              <div class="worksViewMedia">
                <img :src="item.image" width="140" alt="">
              </div>
            </div>
             <div class="worksViewRow flex" v-else>
              <div class="worksViewMedia">
                <img :src="item.image" width="140" alt="">
              </div>
              <div class="worksViewInfo flex-1 worksViewInfo-right">
                <div class="f14 fb">{{$i18n.locale == 'zh'?item.name:item.name2}}</div>
                <div class="f14">{{$i18n.locale == 'zh'?item.title1:item.title2}}</div>
                <div class="worksViewPy">{{item.name3}}<br />{{item.name4}}</div>
              </div>
            </div>
            <div class="boxText pt10">
              {{$i18n.locale == 'zh'?item.content1:item.content2}}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  </div>
</template>

<style scoped>
  .worksViewMedia{
    width: 140px ;
  }
  .worksViewInfo-right{
    text-align: right;
  }
</style>
<script>
import Nav from "@/components/nav.vue";
import Footer from "@/components/footer.vue";
export default {
  name: "App",
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      id: "1",
      dataSoure: {
        1: [
        {
            name:'刘锡津',
            name2:'Liu Xijin',
            name3:'Liu',
            name4:'Xijin',
            title1: "《姑苏印象》",
            title2: "“Symphony of Sizhu”",
            content1:
              "唐代诗人张继的《枫桥夜泊》使世界知道了名城姑苏。今天，古老的苏州城青春焕发、日新月异，如灿烂明珠，举世瞩目。乐曲以“今月曾经照古人”的情怀，抚今追昔，感念日月沧桑，惊叹姑苏今日之辉煌，讴歌苏州人吉祥美丽的家园。",
            content2:
              "Mr. Liu Changyuan is a professor at the Department of Composition at Central Conservatory of Music, master’s supervisor, and vice president of the Chinese Orchestra Composition Committee. In 2018, the Suzhou Chinese Orchestra commissioned Mr. Liu to compose the Chinese Symphony “Symphony of Sizhu”. The material of the work was extracted from the Jiangsu folk song “Beautiful Scenery of Gusu.” Divided into two movements, the music let us hear the Taihu Lake’s boat song, bells of Hanshan Temple, Pingtan in the courtyard, and waves of the water village. The work expresses the composer’s praise towards the water village of Jiangnan and the Suzhou people’s love for the hometown, presenting a strong sense of national pride of the Zhonghua people.",
             image: require("../../assets/media/media-13.png")  
          },
          {
            name:'刘长远',
            name2:'Liu Changyuan',
            name3:'Liu',
            name4:'Changyuan',
            title1: "《丝竹的交响》",
            title2: "“Symphony of Sizhu”",
            content1:
              "这部入选国家文旅部2019年“时代交响—中国交响音乐作品创作扶持计划”的乐团委约作品，以江苏民歌《姑苏好风光》为素材，仿佛让我们听到了太湖的船歌、寒山寺的钟声、庭院中的评弹和江南水乡的浪花，抒发了作者对江南水乡的赞美以及苏州人民深爱故乡之情感，体现了中华儿女强烈的民族自豪感。",
            content2:
              "Mr. Liu Changyuan is a professor at the Department of Composition at Central Conservatory of Music, master’s supervisor, and vice president of the Chinese Orchestra Composition Committee. In 2018, the Suzhou Chinese Orchestra commissioned Mr. Liu to compose the Chinese Symphony “Symphony of Sizhu”. The material of the work was extracted from the Jiangsu folk song “Beautiful Scenery of Gusu.” Divided into two movements, the music let us hear the Taihu Lake’s boat song, bells of Hanshan Temple, Pingtan in the courtyard, and waves of the water village. The work expresses the composer’s praise towards the water village of Jiangnan and the Suzhou people’s love for the hometown, presenting a strong sense of national pride of the Zhonghua people.",
             image: require("../../assets/media/media-2.png")  
          },
          {
             name:'李滨扬',
            name2:'Li Binyang',
            name3:'Li',
            name4:'Binyang',
            title1: "《烟雨枫桥》",
            title2: "“Misty Rain on Maple Bridge”",
            content1:
              "这部入选国家文旅部2019年“时代交响—中国交响音乐作品创作扶持计划”的乐团委约作品，曲名取自杜牧（唐）“暮烟疏雨过枫桥”。在隐约的苏州评弹与昆曲元素的几丝韵味的穿引下，通过时而缥缈，时而清雅，时而梦幻，时而浪漫激越的音乐历程，描绘出曲作者心中的那座令人神往，朦胧斑斓的千年枫桥。",
            content2:
              "Mr. Li Binyang is a professor at the Department of Composition of Central Conservatory of Music, doctorate’s supervisor. In 2018, the Suzhou Chinese Orchestra commissioned Mr. Li to compose the Chinese Symphony “Misty Rain on Maple Bridge.” The title of the piece was inspired by the poem line “Twilight fog and light rain over the maple bridge.” Vaguely lead by the elements of Suzhou Pingtan and Kunqu, through the music journey in the mixture of faintness, elegance, dreamy and romance with aggression, the work depicts the composer’s imagination of the fascinating millennial maple bridge in hazy colors, showing his love for the hometown and the motherland.",
            image: require("../../assets/media/media-3.png") 
          },
          {
             name:'张朝',
            name2:'Zhang Zhao',
            name3:'Zhang',
            name4:'Zhao',
            title1: "《干将·莫邪幻想曲》",
            title2: "“Fantasia of Gan Jiang Mo Ye”",
            content1:
              "这部入选文旅部2018年“时代交响——中国交响音乐作品创作扶持计划”的乐团委约作品，围绕一刚一柔分别代表干将与莫邪的两个主题展开全曲，共由誓言、山雪、烈火、涅槃四个乐章组成，向观众传达了大爱、大义、大勇的精神力量，歌颂了人民与英雄。",
            content2:
              "Mr. Zhang Zhao is a member of the Chinese Musicians’ Association, a professor of the Music School of Minzu University of China, and master’s supervisor. In 2018, the Suzhou Chinese Orchestra commissioned Mr. Zhang to compose the Chinese Symphony “Fantasia of Gan Jiang Mo Ye.” The work was inspired by the touching story of the Suzhou folk legend “Gan Jiang Mo Ye.” Divided into four parts, namely: The Oath, Mountain’s Snow, Inferno, and Nirvana, the work avoids literary narration and emphasizes the expression of the feelings and spirit. The music delivers the spiritual energy of great love, great righteousness and great courage to the audience, and eulogizes the people and the heroes.",
            image: require("../../assets/media/media-4.png") 
          },
          {
            name:'王丹红',
            name2:'Zhao Jiping',
            name3:'zhao',
            name4:'jiping',
            title1: "《四季留园》",
            title2: "“Symphony of Feng-Ya-Song”",
            content1:
              "这部作品以苏州园林春夏秋冬不同的韵味为主基调，以优美、丰富、多变的曲调，分四个乐章体现出春的盎然、夏的奔放、秋的浪漫、冬的雅致，描绘了被喻为“人间天堂”的姑苏美景，歌颂了苏州人民因改革开放所过上的幸福美好生活，表达了人民群众对党、对祖国、对生活的热爱。",
            content2:
              "In 2018, Mr. Zhao composed the “Symphony of Feng-Ya-Song” for the Suzhou Chinese Orchestra. Inspired by the “Classic of Poetry,” the composer had selected the prominent chapters of the collection and with his unique musical language, the work pays tribute to the classic of Zhonghua traditions, eulogizes the motherland, the era, the people, and the heroes, emitting the charm of a large country that leads the new era.",
             image: require("../../assets/media/media-14.png")
          },
          {
            name:'赵季平',
            name2:'Zhao Jiping',
            name3:'zhao',
            name4:'jiping',
            title1: "《风雅颂之交响》",
            title2: "“Symphony of Feng-Ya-Song”",
            content1:
              "作品入选国家文旅部2019年“时代交响—中国交响音乐作品创作扶持计划”。该作品以中华传统文化之诗歌滥觞《诗经》为创作宗旨，选取其中有代表性的章节，作曲家用独特的音乐语言向中华传统经典致敬，讴歌祖国、讴歌时代、讴歌人民、讴歌英雄，充分展现了领航新时代泱泱大国的形象和魅力。作品风格雄壮、典雅，共有《序·颂》《关雎》《玄鸟》《幽兰操》《国风》五个乐章。",
            content2:
              "In 2018, Mr. Zhao composed the “Symphony of Feng-Ya-Song” for the Suzhou Chinese Orchestra. Inspired by the “Classic of Poetry,” the composer had selected the prominent chapters of the collection and with his unique musical language, the work pays tribute to the classic of Zhonghua traditions, eulogizes the motherland, the era, the people, and the heroes, emitting the charm of a large country that leads the new era.",
             image: require("../../assets/media/media-1.png")
          },
          {
             name:'郝维亚',
            name2:'Hao Weiya',
            name3:'Hao',
            name4:'Weiya',
            title1: "《来自苏州的声音》",
            title2: "“The Sounds from Suzhou”",
            content1:
              "这部委约作品以当代人的视角重新感受和审视苏州的独特气息，展现苏州人惬意、舒适的生活。作曲家通过苏州最有代表性、最有怀旧感、最有乡土乡情、最真实的声音表达了对苏州这座古老城市的敬意，对苏州人的喜爱之情。",
            content2:
              "The work was inspired by the composer’s love for the city of Suzhou. Today, it’s very fortunate for us to live in an awesome city like Suzhou which preserves the ancient taste but also meets the need of the development in the era. The work is divided into three movements, with the materials extracted from the “Garden”, “Land” and “Kunqu” of Suzhou respectively, considering the angle of view of the modern people and observing the unique features of Suzhou, it showcases the developmental achievements of Suzhou after 40 years of Reform and Opening-up, eulogizes the wise leadership of the Party and the hard work and wisdom of the people!",
            image: require("../../assets/media/media-5.png")
          }
        ],
        2: [
          {
            name:'李滨扬',
            name2:'Li Binyang',
            name3:'Li',
            name4:'Binyang',
            title1: "《吴越春秋》",
            title2: "“Wu Yue Eras”",
            content1:
              "作曲家从自身的理解出发，以交响手法将吴越之史中部分具有代表性的史实与故事串联展现出来。乐曲以昆曲声腔的部分材料作为原始素材。全曲共分「吴越争霸」「卧薪尝胆」「越女之剑」「干戈再起」「壮哉江南」五个部分。",
            content2:
              `The history of Wu Yue Eras was like a giant scroll painting, a thrilling saga. Observing the history, many of the familiar historical figures, stories and allusions occurred in the eras. The music attempts to use symphonic techniques from the composer's own understanding and perspective to connect and display the representative historical facts and stories in the thrilling Wu Yue epic. The work uses part of Kunqu tune as the original material. The whole symphony is composed of five parts and is performed continuously: "Wu and Yue Strive for Hegemony", "Endurance of Hardship", "Sword of the Yue Maiden", "Resurgence of War" and "Behold Jiangnan".`,
            image: require("../../assets/media/media-3.png") 
          },
          {
            name:'郭文景',
            name2:'Guo Wenjing ',
            name3:'Guo',
            name4:'Wenjing',
            title1: "《桃花庵》",
            title2: "“Peach Blossom Cottage”",
            content1:
              "运用了苏剧、昆曲、评弹等音乐元素的《桃花庵》，取自明代画家、文学家、诗人唐寅创作的一首七言古诗《桃花庵歌》。作品将印象主义与浪漫主义完美结合，通过“古园旧梦”“飞花漫天”两个乐章，歌颂了古人积极达观的精神与不和世俗同流的刚正风骨。",
            content2:
              "The work was inspired by the seven-sentence ancient poem “Song of the Peach Blossom Cottage” written by Tang Yin (painter, writer, and poet of Ming Dynasty). It mainly expresses the poet’s life attitude that he is willing to live away from the secular world and indifferent to fame. With the constant tension of the music, the work eulogizes the valuable spirit and integrity of the ancient people who pursued freedom and cherished the value of life.",
            image: require("../../assets/media/media-7.png") 
          },
          {
            name:'张朝',
            name2:'Li Binyang',
            name3:'Li',
            name4:'Binyang',
            title1: "《琴动山河》",
            title2: "“Wu Yue Eras”",
            content1:
              "这部乐团作品以钢琴与民族管弦乐队协奏的形式，以四个乐章熔传统、现代、民族、流行音乐为一炉，呈现具有中西合璧、时代气息与雅俗共赏的特质。曲中描绘了祖国大地长江、长城、黄山、黄河、江苏、江南的沧桑巨变，歌颂了中华儿女勤劳勇敢、不畏艰难的民族精神与风骨美德，讴歌了当代中国在党的领导下开创崭新时代的巨大成就，为中国共产党成立100周年献礼。",
            content2:
              `The history of Wu Yue Eras was like a giant scroll painting, a thrilling saga. Observing the history, many of the familiar historical figures, stories and allusions occurred in the eras. The music attempts to use symphonic techniques from the composer's own understanding and perspective to connect and display the representative historical facts and stories in the thrilling Wu Yue epic. The work uses part of Kunqu tune as the original material. The whole symphony is composed of five parts and is performed continuously: "Wu and Yue Strive for Hegemony", "Endurance of Hardship", "Sword of the Yue Maiden", "Resurgence of War" and "Behold Jiangnan".`,
            image: require("../../assets/media/media-3.png") 
          },
          {
            name:'姜莹',
            name2:'Jiang Ying',
            name3:'Jiang',
            name4:'Ying',
            title1: "《艰难与辉煌》",
            title2: "“Hardship and Glory”",
            content1:
              "这部入选文旅部2020-2021年度“时代交响——中国交响音乐作品创作扶持计划”的作品，以叙述性的创作方式展开，主题动机运用了《国际歌》的素材并贯穿始终，使音乐具有强烈的英雄主义气质。今天，我们缅怀用热血和信仰铸就革命伟大胜利的英雄，描绘波澜壮阔的革命历史，为中华民族崭新的时代谱写辉煌的乐章。此曲献给中国共产党成立100周年。",
            content2:
              "The people of Zhonghua had gone through a hundred years of vicissitudes in the 20th century. It was the ideal and belief of revolutionary martyrs to realize communism that brought about China today. The work exposes via a narrative manner and the theme is adopted from “L’Internationale), which radiates a strong sense of heroism. We remember the heroes, it is they who achieved the great success of the revolution with their passion and faith. This is a work that aims to symphonize the Chinese traditional orchestra and to present the epic history of the revolution. Today, we stay true to our original aspiration and founding mission and compose the glorious movements for the new era of Zhonghua people. This work is a tribute to the 100th Anniversary of the Founding of CPC.",
            image: require("../../assets/media/media-6.png")
          },
          {
            name:'刘长远',
            name2:'Li Binyang',
            name3:'Li',
            name4:'Binyang',
            title1: "《光明》",
            title2: "“Wu Yue Eras”",
            content1:
              "作曲家以生机、交锋、大爱、家园、光明五个乐章，挖掘民族音乐的叙事性，赋予民族交响新的意义。作品描述人们怀揣着追寻光明的梦想，与苦难、灾难抗争，在千难万险、千辛万苦中寻找出路。其间，他们深切感受来自祖国、母亲与人类的大爱，守护共同家园，最终穿越黑暗、跨越死亡、战胜风浪的壮阔心路历程。",
            content2:
              `The history of Wu Yue Eras was like a giant scroll painting, a thrilling saga. Observing the history, many of the familiar historical figures, stories and allusions occurred in the eras. The music attempts to use symphonic techniques from the composer's own understanding and perspective to connect and display the representative historical facts and stories in the thrilling Wu Yue epic. The work uses part of Kunqu tune as the original material. The whole symphony is composed of five parts and is performed continuously: "Wu and Yue Strive for Hegemony", "Endurance of Hardship", "Sword of the Yue Maiden", "Resurgence of War" and "Behold Jiangnan".`,
            image: require("../../assets/media/media-3.png") 
          },
        ],
        3: [
          {
            name:'唐建平',
            name2:'Tang Jianping',
            name3:'Tang',
            name4:'Jianping',
            title1: "《江河湖海颂》",
            title2: "“Ode to Rivers, Lakes and the Sea”",
            content1:
              "这部根据江苏省所具有完整的江、河、湖、海汇聚而成的水韵风采为艺术题材，以大型民族管弦乐为载体而创作的交响音乐作品由唐建平作曲、葛逊作词，力求以习近平新时代中国特色社会主义文艺思想和历史唯物主义文艺观确立为这部作品的思想和精神高度、精神追求，并汲取江苏这片土地上的文化精粹、人文风采和风土人情建构出既有厚重历史感，又有江南风韵浓郁的音乐篇章，讴歌中华民族的伟大历史和文化成就，讴歌中国人民生生不息的生命精神和生活情感。作品由八个乐章组成。",
            content2:
              "Jiangsu people have a mind as broad as the rivers, lakes and the sea since ancient times. The work eulogizes the water-cultivated Jiangsu’s humanism and nature, the great journey and history of the building of CPC, the transformation on the land of China since hundred years ago, and the great achievements until the 100th Anniversary of the Founding of CPC.",
            image: require("../../assets/media/media-8.png")
          },
          {
            name:'刘长远',
            name2:'LIU CHANGYUAN',
            name3:'LIU',
            name4:'CHANGYUAN',
            title1: "《征程·光明》",
            title2: "Liu Changyuan - Journey·Light: a Chinese symphony",
            content1: "作品描绘了一代代中国脊梁在家国情怀的激励下，为民族复兴、国家前途、人类命运无怨无悔、毅然决然地踏上征程、奔向光明的奋斗史，歌颂了中国共产党人为推动中华民族浩荡前行、为构建人类命运共同体所作出的巨大贡献和历史担当。作品由《序》《征程》《光明》三个部分组成。",
            content2:"The Chinese symphonic work Journey · Light employs an epic narrative and profound emotions to depict a magnificent panorama of the Chinese nation in pursuit of light and rejuvenation. Diverse emotions unfold progressively through the music, from the cheerful and lively at the beginning to the complex and changeful, from the gentle and profound to the harmonious and melodious. Ultimately, a powerful and stirring melody resounds throughout the house, voicing a heartfelt call for truth and light while celebrating the indomitable spirit of the Chinese people.",
            image: require("../../assets/media/media-2.png")
          },
          {
            name:'关乃忠',
            name2:'GUAN NAIZHONG',
            name3:'GUAN',
            name4:'NAIZHONG',
            title1: "《复兴》",
            title2: "Guan Naizhong - Chinese Symphony No.5 “Rejuvenation”",
            content1: "作曲家充分借鉴西方交响乐的创作手段，立足于中国民族音乐传统，融入中国传统哲学思想，以苏州弹词开篇为动机，引用《撒金沙》《水鼓子》《慢曲子西江月》《长沙女引》《苏合香》《胡旋舞》《倾杯乐》等敦煌琵琶曲为素材，串联起五个乐章，以盛唐气象为切入点，描述了一个伟大民族的荣辱悲欢，预示着中华民族的复兴强盛。乐曲所引用的唐代旋律除了节奏的变动和部分乐句的重复外，几乎没有改动，却体现出强烈而灵动的现代感，音乐的生命力和人们对理想世界的祈愿一样，亘古不变，历久弥新。",
            content2:"Rooted in Chinese traditional music, the entire composition fully utilizes the creative techniques of Western symphonic music with the incorporation of traditional Chinese philosophical ideas. Starting with an opening ballad in Suzhou pingtan as the motif, it quotes Dunhuang pipa tunes, connecting them in five movements. With the grandeur of the Tang Dynasty as the starting point, it describes the rise and fall of a great nation, heralding the resurgence and prosperity of the Chinese nation.",
            image: require("../../assets/media/media-11.png")
          },
          {
            name:'徐昌俊',
            name2:'XU CHANGJUN',
            name3:'XU',
            name4:'CHANGJUN',
            title1: "《江南》",
            title2: "Xu Changjun - Symphonic Suite “Jiangnan”",
            content1: "作曲家通过叙事交响音画的创作手法，把具有江南地域元素的五个乐章主题贯穿其间，并将此五幅相对独立的音画有机地串联起来。追求新颖、独特地域特色、可听性与创新性有机结合，融昆曲、评弹、古琴、编钟等艺术形式与民族管弦乐队为一体，用丝竹交响描绘锦绣江南。",
            content2:"In the genre of a multi-movement symphonic suite, “Jiangnan” utilizes the composition technique of a narrative symphonic tableaux, featuring unique regional characteristics and the combination of audibility and novelty. By seamlessly integrating Kunqu opera, pingtan, guqin and bianzhong into the Chinese orchestra, the suite depicts the picturesque beauty of Jiangnan (the southern Yangtze region).",
            image: require("../../assets/media/media-9.png") 
          },
          {
            name:'李博',
            name2:'LI BO',
            name3:'LI',
            name4:'BO',
            title1: "《和平之光》",
            title2: "Li Bo - The Light of Peace: a Chinese symphony",
            content1: "习近平总书记在党的二十大报告中提出“促进世界和平与发展，推动构建人类命运共同体”。正值中国人民抗日战争暨世界反法西斯战争胜利80周年之际，作曲家应约创作了这部向世界发出和平呼唤的大型民族管弦乐作品。作品以中国古代军事家孙武的心路历程及其兵法思想为主线，诠释和平与发展的时代主题。作曲家在构思时把世界音乐语汇融入中国语境，从中华五千年文明史的璀璨成果和深厚积淀中汲取智慧，以四个乐章的形式向世界阐释中华文明和平理念。",
            content2:"In his speech Working Together to Build a Community with a Shared Future for Humanity delivered at the United Nations Office in Geneva, President Xi Jinping remarked: “The Art of War” by Sun Tzu is a renowned Chinese military book, but its very first sentence reads “Warfare is a matter of vital importance to the state. It is a matter of life and death, a road either to survival or to ruin. Hence it is a subject for careful study.” Its core principle is prudence in waging war and preference for avoiding it. For thousands of years, peace has been ingrained in the lifeblood of the Chinese nation and etched into the DNA of the Chinese people.",
            image: require("../../assets/media/media-12.png")
          },
          // {
          //    name:'徐昌俊',
          //   name2:'Xu Changjun',
          //   name3:'Xu',
          //   name4:'Changjun',
          //   title1: "《虎丘的传说》",
          //   title2: "“The Legend of Huqiu”",
          //   content1:
          //     "宋代大诗人苏东坡写下“尝言过姑苏不游虎丘，不谒闾丘，乃二欠事”的千古名言。该作品以虎丘各种历史典故与美丽传说为素材，创设穿越时空的美妙意境，歌颂中华民族悠久而灿烂的历史文化！",
          //   content2:
          //     "The great poet of Song Dynasty - Su Dongpo wrote the famous phrase: “Coming to Suzhou, it’ll be a regret if I don’t go to Huqiu and pay a visit to my friend Lv Qiu”. The work refers to the history and legend that occurred in Huqiu, traveling in time and space, it eulogizes the brilliant historical culture of the Zhonghua people.",
          //   image: require("../../assets/media/media-9.png")
          // },
          // {
          //    name:'唐建平',
          //   name2:'Tang Jianping',
          //   name3:'Tang',
          //   name4:'Jianping',
          //   title1: "唐建平《苏风三月》",
          //   title2: "“The Suzhou Wind in March”",
          //   content1:
          //     "该作品描绘了姑苏大地春天时分的自然景象，欢快悠扬，甜美抒情，使人仿佛置身于幽曲明净、精巧秀丽的姑苏园林和春光明媚的江南原野之中，展示了江南三月，万物争春，一派人间天堂春意盎然的美景！象征在党的领导下，国家各项事业蒸蒸日上、人民生活幸福安康的盛世景象！",
          //   content2:
          //     "The work depicts the nature view of the Suzhou in spring season. Set in a happy mood, sweet and sentimental, the music brings the audience into a beautiful garden and bright wilderness in Jiangnan in spring season, presenting the March in Jiangnan, all living trees and animals are vibrant and full of energy, symbolizing that under the leadership of the Party, the country develops fast in various fields, and the people are living healthily in prosperity!",
          //   image: require("../../assets/media/media-8.png")
          // },
          // {
          //   name:'张朝',
          //   name2:'Zhang Zhao',
          //   name3:'Zhang',
          //   name4:'Zhao',
          //   title1: "《苏州日记》",
          //   title2: "“Suzhou Diary”",
          //   content1:
          //     "作品以苏州人的生活经历为线索，展现苏州人多彩的人生与对美好生活向往的火热情怀，歌颂了当代中国的繁荣富强与中国人民走进新时代过上的幸福日子！",
          //   content2:
          //     "The work was inspired by the living experience of Suzhou citizens, showcasing the wonderful life and passion of living of the people, eulogizing the prosperity of China and the happy life of the Chinese people in the new era!",
          // image: require("../../assets/media/media-4.png") 
          // },
        ],
        4: [
          {
            name:'徐昌俊',
            name2:'XU CHANGJUN',
            name3:'XU',
            name4:'CHANGJUN',
            title1: "交响组曲「江南」",
            title2: "Xu Changjun - Symphonic Suite “Jiangnan”",
            content1: "《江南》采用多乐章交响组曲的体裁形式，通过叙事交响乐音画的创作手法，追求新颖、独特地域特色、可听性与创新性有机结合，将昆曲、评弹、古琴、编钟等艺术与民族管弦乐队融为一体，用音乐描绘锦绣江南。",
            content2:"In the genre of a multi-movement symphonic suite, “Jiangnan” utilizes the composition technique of a narrative symphonic tableaux, featuring unique regional characteristics and the combination of audibility and novelty. By seamlessly integrating Kunqu opera, pingtan, guqin and bianzhong into the Chinese orchestra, the suite depicts the picturesque beauty of Jiangnan (the southern Yangtze region).",
            image: require("../../assets/media/media-9.png") 
          },
          {
            name:'刘长远',
            name2:'LIU CHANGYUAN',
            name3:'LIU',
            name4:'CHANGYUAN',
            title1: "中国交响乐《征程·光明》",
            title2: "Liu Changyuan - Journey·Light: a Chinese symphony",
            content1: "中国交响乐《征程·光明》以史诗般的叙事和深邃的情感，描绘了中华民族在追求光明与复兴道路上的壮丽图景。多样化的情感在乐声中层层递进，从一开始的欢快跃动到复杂多变，从温柔深邃到和谐悠扬，最后激昂有力的旋律响彻全场，抒发出对真理与光明的深切呼唤，颂扬了中华民族坚韧不拔的精神品质。",
            content2:"The Chinese symphonic work Journey · Light employs an epic narrative and profound emotions to depict a magnificent panorama of the Chinese nation in pursuit of light and rejuvenation. Diverse emotions unfold progressively through the music, from the cheerful and lively at the beginning to the complex and changeful, from the gentle and profound to the harmonious and melodious. Ultimately, a powerful and stirring melody resounds throughout the house, voicing a heartfelt call for truth and light while celebrating the indomitable spirit of the Chinese people.",
            image: require("../../assets/media/media-2.png")
          },
          // {
          //   name:'关乃忠',
          //   name2:'GUAN NAIZHONG',
          //   name3:'GUAN',
          //   name4:'NAIZHONG',
          //   title1: "关第四交响乐·第四乐章",
          //   title2: "Guan Naizhong - Movement from Symphony No.4",
          //   content1: "整个乐章充满了欢快和喜悦的气氛，引用了“步步高”的旋律。三连音、五连音在不同的声部形成了复合的节奏。闪光、跳动融合成了一片欢乐的海洋，这也许就是我们无悔青春的写照吧",
          //   content2:"The movement incorporates the melody of Bu Bu Gao (Ascending Step by Step) so that it is filled with cheer and joy throughout. The use of triplets and quintuplets in different parts creates a compound rhythm. Sparkling and bouncing elements merge into a sea of joy, conceivably reflecting a portrayal of us having no regrets about our youth.",
          //   image: require("../../assets/media/media-11.png")
          // },
          {
            name:'关乃忠',
            name2:'GUAN NAIZHONG',
            name3:'GUAN',
            name4:'NAIZHONG',
            title1: "第五中国交响乐《复兴》",
            title2: "Guan Naizhong - Chinese Symphony No.5 “Rejuvenation”",
            content1: "乐曲充分借鉴西方交响乐的创作手段，立足于中国民族音乐传统，融入中国传统哲学思想，以苏州弹词开篇为动机，引用敦煌琵琶曲为素材，串联起五个乐章，以盛唐气象为切入点，描述了一个伟大民族的荣辱悲欢，预示着中华民族的复兴强盛。",
            content2:"Rooted in Chinese traditional music, the entire composition fully utilizes the creative techniques of Western symphonic music with the incorporation of traditional Chinese philosophical ideas. Starting with an opening ballad in Suzhou pingtan as the motif, it quotes Dunhuang pipa tunes, connecting them in five movements. With the grandeur of the Tang Dynasty as the starting point, it describes the rise and fall of a great nation, heralding the resurgence and prosperity of the Chinese nation.",
            image: require("../../assets/media/media-11.png")
          },
          // {
          //   name:'刘长远',
          //   name2:'LIU CHANGYUAN',
          //   name3:'LIU',
          //   name4:'CHANGYUAN',
          //   title1: "中国管弦乐《苏州好风光》",
          //   title2: "Liu Changyuan - Beautiful Scenery of Suzhou: a Chinese symphony",
          //   content1: "作品旋律变换细腻，热烈快板渐进至深情慢板，最终升华至激昂广板，精妙展现了苏州独有的风雅景致。",
          //   content2:"The piece features delicate melodic transitions, progressing from a lively allegro to an affectionate adagio, and ultimately soaring to an impassioned largo. It exquisitely captures the unique elegance and charm of Suzhou's scenery.",
          //   image: require("../../assets/media/media-2.png")
          // },
          {
            name:'龚华华',
            name2:'GONG HUAHUA',
            name3:'GONG',
            name4:'HUAHUA',
            title1: "第一中国交响乐《楚魂》",
            title2: "Gong Huahua - Chinese Symphony No.1 “The Soul of Chu”",
            content1: "作曲家龚华华以古楚国地域民间音乐作为素材，结合自己对文献中楚国之“魂”的理解，试图以当代人的视角讲述楚国的故事、刻画楚地的场景、展现楚人的精神与气质，本作品此次为世界首演。",
            content2:"The composer Gong Huahua draws on the folk music of the area of ​​ancient Chu State, combining it with his interpretation of the “soul” of Chu in historical documents. Through a contemporary lens, he seeks to tell the story of Chu, depict its landscapes, and embody the spirit and character of its people. The performance of the work this time is the world premiere.",
            image: require("../../assets/media/media-10.png")
          },
          {
            name:'李博',
            name2:'LI BO',
            name3:'LI',
            name4:'BO',
            title1: "民族管弦乐《和平之光》",
            title2: "Li Bo - The Light of Peace: a Chinese symphony",
            content1: "习总书记曾在联合国日内瓦总部发表的题为《共同构建人类命运共同体》的演讲中说：中国《孙子兵法》是一部著名兵书，但其第一句话就讲：“兵者，国之大事，死生之地，存亡之道，不可不察也”，其要义是慎战、不战。几千年来，和平融入了中华民族的血脉中，刻进了中国人民的基因里。",
            content2:"In his speech Working Together to Build a Community with a Shared Future for Humanity delivered at the United Nations Office in Geneva, President Xi Jinping remarked: “The Art of War” by Sun Tzu is a renowned Chinese military book, but its very first sentence reads “Warfare is a matter of vital importance to the state. It is a matter of life and death, a road either to survival or to ruin. Hence it is a subject for careful study.” Its core principle is prudence in waging war and preference for avoiding it. For thousands of years, peace has been ingrained in the lifeblood of the Chinese nation and etched into the DNA of the Chinese people.",
            image: require("../../assets/media/media-12.png")
          },
        ],
      },
      dateTitle: {
        1: "2017~2019",
        2: "2020~2021",
        3: "2022~2024"
      },
    };
  },
  computed: {
     contents() {
      return this.dataSoure[this.id]
    },
    titleText(){
      return this.dateTitle[this.id]
    }
  },
  created(){
    this.id = this.$route.params.id || 0;
  },
  mounted() {},
  methods: {
    // getCompanys(){
    // }
  },
};
</script>

